import { IErrorItem } from '~src/commonInfra/contentActions/MultipleItemResult';
import { openReactConfirmationDialog } from '~src/commonInfra/dialogs/ReactConfirmationDialog';
import { TabDialogWidth } from '~src/commonInfra/dialogs/style/TabDialogWidth';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';
import { IScheduleInfo } from '~src/schedule/types/IScheduleInfo';

import { Messages } from '../../codegen/Localize';
import {
  ActionHelpers,
  standardActionErrorMsg,
  standardActionSuccessMsg
} from '../../commonInfra/contentActions/ActionHelpers';
import { L10n } from '../../ts/L10n/L10n';
import { Set } from '../../ts/models/Set';
import { SchedulesService } from '../../ts/resources/Schedules';
import { ScheduleErrorsService } from '../../ts/services/ScheduleErrors';

export namespace RunServerSchedulesActionService {
  export function execute(schedules: IScheduleInfo[]): Promise<IResult> {
    const dialog = openReactConfirmationDialog<string[], IResult>({
      title: Messages.runNow(),
      message: Messages.schedulesRunPrompt({
        ITEM_COUNT: schedules.length,
        ITEM_COUNT_LOC: L10n.localizedCount(schedules.length),
        ITEM_NAME: L10n.elideIfLong(schedules[0].name),
      }),
      actionName: Messages.runNowConfirmButton(),
      action: (ids: string[]) => SchedulesService.runServer(ids),
      isActionDelete: false,
      paramsForAction: schedules.map(schedule => schedule.id),
      dialogWidth: TabDialogWidth.width375px,
    });

    dialog.result.then(result => notifyResult(schedules, result));
    return dialog.result;
  }

  function notifyResult(schedules: IScheduleInfo[], result: IResult) {
    const toastText = {
      success: standardActionSuccessMsg(Messages.schedulesRunSuccess),
      error: standardActionErrorMsg(Messages.schedulesRunError),
    };
    ActionHelpers.displayStandardToastsForResult(Set.fromIdItemArray(schedules), result, toastText, (error: IErrorItem<IScheduleInfo>) => ScheduleErrorsService.errorDetailsFor(error));
  }
}
